import React from 'react';

function MobileEdit() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18.399'
      height='18.399'
      viewBox='0 0 18.399 18.399'
    >
      <g stroke='#fff' strokeWidth='0.2' data-name='Group 13130' transform='translate(-2.9 -1.871)'>
        <path
          d='M18.288 2.012l2.869 2.869-2.187 2.188L16.101 4.2zM7.781 15.388h2.869l6.968-6.968-2.869-2.869-6.968 6.968z'
          data-name='Path 361'
        />
        <path
          d='M18.3 18.257H7.932c-.025 0-.051.01-.076.01s-.063-.009-.1-.01H4.912V4.869h6.548l1.912-1.912h-8.46A1.914 1.914 0 003 4.869v13.388a1.914 1.914 0 001.912 1.912H18.3a1.912 1.912 0 001.912-1.912V9.968L18.3 11.881z'
          data-name='Path 362'
        />
      </g>
    </svg>
  );
}

export default MobileEdit;
